import { graphql } from '../gql'

/**
 * GraphQL operations for the operator's organizations.
 */

/** Query: All organizations the current operator can switch into. */
export const MyOrganizationsQuery = graphql(`
	query MyOrganizationsQuery {
		myOrganizations {
			id
			name
			logo
			primaryColor
		}
	}
`)
